import { StageSchemeDefinition } from "./stage-types";
import { BackgroundColor } from "../../background/constants/background-types";
import { HEADLINE_SIZE_H1, HEADLINE_SIZE_H2, HEADLINE_SIZE_H3 } from "../../headline/constants/headline-constants";
import * as AllColors from "../../../constants/colors";
import { toConstantCase } from "../../../utils/string-format";
import { createStageMapDefinition } from "../../../utils/scheme-helper";

export const STAGE_POSITION_TOP = "top";
export const STAGE_POSITION_CENTER = "center";
export const STAGE_POSITION_BOTTOM = "bottom";

export const STAGE_WIDTH_WIDE = "wide";
export const STAGE_WIDTH_NORMAL = "normal";
export const STAGE_WIDTH_NARROW = "narrow";

export const STAGE_INDICATOR_COLOR_LIGHT = "light";
export const STAGE_INDICATOR_COLOR_DARK = "dark";

export const STAGE_VIDEO_CONTROL_COLOR_LIGHT = "light";
export const STAGE_VIDEO_CONTROL_COLOR_DARK = "dark";

export const STAGE_POSITIONS = [STAGE_POSITION_TOP, STAGE_POSITION_CENTER, STAGE_POSITION_BOTTOM] as const;
export const STAGE_WIDTHS = [STAGE_WIDTH_WIDE, STAGE_WIDTH_NORMAL, STAGE_WIDTH_NARROW] as const;
export const STAGE_INDICATOR_COLORS = [STAGE_INDICATOR_COLOR_LIGHT, STAGE_INDICATOR_COLOR_DARK] as const;
export const STAGE_HEADLINE_SIZES = [HEADLINE_SIZE_H1, HEADLINE_SIZE_H2, HEADLINE_SIZE_H3] as const;
export const STAGE_VIDEO_CONTROL_COLORS = [STAGE_VIDEO_CONTROL_COLOR_LIGHT, STAGE_VIDEO_CONTROL_COLOR_DARK] as const;

function createSchemes() {
  let newSchemes: AllColors.StageSchemeConfiguration<StageSchemeDefinition> = {};
  AllColors.STAGE_SCHEMES.forEach((element) => {
    newSchemes[element.schemeName] = {
      contentBoxBackgroundColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      contentBoxBackgroundColorBlurred: AllColors[`COLOR_${toConstantCase(element.schemeName)}_OPACITY_90`],
      contentBoxSubheadlineColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`],
      contentBoxHeadlineScheme: "",
      contentBoxLinkScheme: "",
      contentBoxButtonScheme: "",
      subheadlineColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      headlineScheme: "",
      linkScheme: "",
      buttonScheme: ""
    };
    if (element.scheme) {
      newSchemes[element.schemeName] = { ...newSchemes[element.schemeName], ...element.scheme };
    }
  });
  return newSchemes;
}

export const STAGE_SCHEME_CONFIG: AllColors.StageSchemeConfiguration<StageSchemeDefinition> = createSchemes();

export const STAGE_SCHEME_MAP: Map<BackgroundColor | "default", StageSchemeDefinition> = new Map(
  Object.entries(createStageMapDefinition()).map(([background, config]) => [
    background as BackgroundColor,
    STAGE_SCHEME_CONFIG[config as string]
  ])
);
